var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24879 8.76482L7.97221 10.4882M7.97221 10.4882L6.24879 12.2117M7.97221 10.4882H1.37109M2.51665 8.33396C3.26162 7.04613 4.65402 6.17969 6.24879 6.17969C8.62832 6.17969 10.5573 8.10869 10.5573 10.4882C10.5573 12.8678 8.62832 14.7968 6.24879 14.7968C4.65402 14.7968 3.26162 13.9303 2.51665 12.6425",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.43935C2 4.25749 2 2.61098 2.23356 2.15957C2.439 1.7625 2.76658 1.4399 3.16978 1.23759C3.62816 1.00758 4.22867 1.00758 5.42878 1.00758H10.2229C10.3543 1.00758 10.4695 1.00758 10.5718 1.0085L13.7857 1.00758C14.5807 0.985062 16.2337 0.999538 16.4864 1.23759C16.759 1.41892 17.0005 1.71376 17 2.15957C16.9992 2.92619 16.999 5.93154 16.999 7.33839C16.999 7.33839 17 7.5526 17 7.68203V16.6273C17 17.8069 17 18.3967 16.7667 18.8477C16.5612 19.2447 16.2326 19.5679 15.8294 19.7702C15.3714 20 14.7725 20 13.5747 20L5.42529 20C4.2275 20 3.62772 20 3.16978 19.7702C2.76658 19.5679 2.439 19.2447 2.23356 18.8477C2 18.3963 2 16.7505 2 15.5686",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductlog);
export default __webpack_public_path__ + "static/media/productlog.5e2a1fbbe98315ea1e210bcec6781bef.svg";
export { ForwardRef as ReactComponent };